import Tile from "../Tile/Tile";
import type { ResourceTileProps } from "../../utils/contentful-helpers";
import { bookmarkEventBuilder, sendEvent } from "../../utils/event-helpers";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { toggleResourceBookmark } from "../../stores/bookmarks/resourceBookmarksSlice";
import styles from "./ResourcePage.module.css";

interface ResourceTilesGridProps {
  resourceTiles: ResourceTileProps[];
  bookmarkSource: string;
}

const ResourceTilesGrid = ({
  resourceTiles,
  bookmarkSource,
}: ResourceTilesGridProps) => {
  const dispatch = useAppDispatch();
  const { userId, sessionId } = useAppSelector((state) => state.session);
  const bookmarks = useAppSelector(
    (state) => state.resourceBookmarks.bookmarks,
  );

  const handleBookmark = (resourceTile: ResourceTileProps) => {
    if (!userId || !sessionId) return;

    const { id, title, description } = resourceTile;
    const isBookmarked = bookmarks.some(
      (bookmark) => bookmark.resourceId === id,
    );

    const eventData = bookmarkEventBuilder(
      !isBookmarked,
      userId,
      sessionId,
      bookmarkSource,
      title,
      {
        bookmarkedResource: {
          title,
          description: JSON.stringify(description),
          resource_id: id,
        },
      },
    );

    void dispatch(sendEvent(eventData));
    dispatch(toggleResourceBookmark({ userId, resourceId: id }));
  };

  return (
    <div className={styles.resourcePageTilesGrid}>
      {resourceTiles.map((tile) => (
        <Tile
          key={tile.id}
          id={tile.id}
          title={tile.title}
          description={tile.description}
          thumbnail={tile.thumbnail}
          url={tile.url}
          isResearchPage={false}
          onBookmark={() => {
            handleBookmark(tile);
          }}
        />
      ))}
    </div>
  );
};

export default ResourceTilesGrid;
